// extracted by mini-css-extract-plugin
export default {"root":"sKd9h","textContainer":"cMlgA","textContent":"SaUk3","onCloseButton":"ZUzZ0"};